const ADD_TO_CART = 'cart/ADD_TO_CART';
const REMOVE_FROM_CART = 'cart/REMOVE_FROM_CART';
const UPDATE_QUANTITY = 'cart/UPDATE_QUANTITY';
const UPDATE_CART_ITEM_VARIANT = 'cart/UPDATE_CART_ITEM_VARIANT';
const CLEAR_CART = 'cart/CLEAR_CART';
const SET_CART_OPEN = 'cart/SET_CART_OPEN';

const initialState = {
  items: [],
  isOpen: false,
};

export const addToCart = (item) => ({
  type: ADD_TO_CART,
  payload: item,
});

export const removeFromCart = (index) => ({
  type: REMOVE_FROM_CART,
  payload: index,
});

export const updateQuantity = (index, delta) => ({
  type: UPDATE_QUANTITY,
  payload: { index, delta },
});

export const updateCartItemVariant = (index, variant) => ({
  type: UPDATE_CART_ITEM_VARIANT,
  payload: { index, variant },
});

export const clearCart = () => ({
  type: CLEAR_CART,
});

export const setCartOpen = (isOpen) => ({
  type: SET_CART_OPEN,
  payload: isOpen,
});

const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TO_CART: {
      const newItem = action.payload;
      const maxQty = newItem.availableQty || 999;
      const existingIndex = state.items.findIndex(
        (item) =>
          item.productId === newItem.productId &&
          item.variantId === newItem.variantId
      );

      if (existingIndex >= 0) {
        const updatedItems = [...state.items];
        const current = updatedItems[existingIndex];
        const currentQty = current.qty;
        const addQty = newItem.qty || 1;
        const newQty = Math.min(currentQty + addQty, maxQty);
        updatedItems[existingIndex] = {
          ...current,
          ...newItem,
          qty: newQty,
          image: newItem.image || current.image,
          availableQty: maxQty,
          variants: (newItem.variants?.length ? newItem.variants : current.variants) || [],
        };
        return { ...state, items: updatedItems };
      }

      const itemQty = Math.min(newItem.qty || 1, maxQty);
      return { ...state, items: [...state.items, { ...newItem, qty: itemQty, availableQty: maxQty, variants: newItem.variants || [] }] };
    }

    case UPDATE_CART_ITEM_VARIANT: {
      const { index, variant } = action.payload;
      if (index < 0 || index >= state.items.length || !variant) return state;
      const updatedItems = [...state.items];
      const item = updatedItems[index];
      const baseName = item.baseProductName || item.name?.replace(/\s*\([^)]*\)\s*$/, '') || item.name;
      const lotProduction = variant.lot_number && Array.isArray(variant.production)
        ? variant.production[0]
        : null;

      const variantQty = variant.lot_number
        ? (lotProduction?.quantity ?? variant.quantity ?? 0)
        : (variant.quantity ?? 0);

      const newQty = Math.min(item.qty, variantQty || item.qty);
      updatedItems[index] = {
        ...item,
        variant,
        variantId: variant._id ?? null,
        variantColor: variant.color ?? null,
        price: variant.lot_number
          ? (lotProduction?.price ?? variant.price ?? item.price)
          : (variant.price ?? item.price),
        availableQty: variantQty || 999,
        name: variant.lot_number
          ? `${baseName} (Lot #${variant.lot_number})`
          : (variant.color ? `${baseName} (${variant.color})` : baseName),
        qty: newQty,
      };
      return { ...state, items: updatedItems };
    }

    case REMOVE_FROM_CART: {
      return {
        ...state,
        items: state.items.filter((_, index) => index !== action.payload),
      };
    }

    case UPDATE_QUANTITY: {
      const { index, delta } = action.payload;
      const updatedItems = [...state.items];
      const item = updatedItems[index];
      const maxQty = item.availableQty || 999;
      const newQty = Math.min(Math.max(1, item.qty + delta), maxQty);
      updatedItems[index] = { ...updatedItems[index], qty: newQty };
      return { ...state, items: updatedItems };
    }

    case CLEAR_CART: {
      return { ...state, items: [] };
    }

    case SET_CART_OPEN: {
      return { ...state, isOpen: action.payload };
    }

    default:
      return state;
  }
};

export default cartReducer;
